import { render, staticRenderFns } from "./class-update-modal.vue?vue&type=template&id=1d806e1c&scoped=true"
import script from "./class-update-modal.vue?vue&type=script&lang=js"
export * from "./class-update-modal.vue?vue&type=script&lang=js"
import style0 from "./class-update-modal.vue?vue&type=style&index=0&id=1d806e1c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d806e1c",
  null
  
)

export default component.exports